import { render, staticRenderFns } from "./VanKey.vue?vue&type=template&id=4e6a51bb&"
import script from "./VanKey.vue?vue&type=script&lang=js&"
export * from "./VanKey.vue?vue&type=script&lang=js&"
import style0 from "./VanKey.vue?vue&type=style&index=0&id=4e6a51bb&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6a51bb')) {
      api.createRecord('4e6a51bb', component.options)
    } else {
      api.reload('4e6a51bb', component.options)
    }
    module.hot.accept("./VanKey.vue?vue&type=template&id=4e6a51bb&", function () {
      api.rerender('4e6a51bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/VanKey.vue"
export default component.exports